import type { TooltipRenderProps } from "react-joyride";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { Trans } from "@lingui/react/macro";

export function TourTooltip({
  backProps,
  closeProps,
  continuous,
  index,
  isLastStep,
  primaryProps,
  size,
  skipProps,
  step,
  tooltipProps,
}: TooltipRenderProps) {
  return (
    <div
      {...tooltipProps}
      className="w-80 rounded-lg border border-(--color-border) bg-(--color-surface-content) p-4 text-(--color-text-primary) shadow-lg"
    >
      {/* Close button */}
      <button
        {...closeProps}
        type="button"
        className="absolute right-2 top-2 rounded-sm p-1 opacity-70 hover:opacity-100"
      >
        <X className="h-4 w-4" />
      </button>

      {step.title && (
        <h3 className="mb-2 text-sm font-semibold leading-none text-(--color-text-primary)">
          {step.title}
        </h3>
      )}
      <div className="text-sm text-(--color-text-secondary)">{step.content}</div>

      {/* Progress bar */}
      <div className="mt-3 mb-3 h-1 w-full rounded-full bg-(--color-surface-muted)">
        <div
          className="h-1 rounded-full bg-(--color-action) transition-all"
          style={{ width: `${((index + 1) / size) * 100}%` }}
        />
      </div>

      <div className="flex items-center justify-between gap-2">
        {!isLastStep && (
          <button
            {...skipProps}
            type="button"
            className="text-xs text-(--color-text-secondary) hover:text-(--color-text-primary)"
          >
            <Trans>Skip tour</Trans>
          </button>
        )}
        <div className="ml-auto flex items-center gap-2">
          {index > 0 && (
            <Button {...backProps} variant="outline" size="sm">
              <Trans>Back</Trans>
            </Button>
          )}
          {continuous && (
            <Button {...primaryProps} size="sm">
              {isLastStep ? <Trans>Finish</Trans> : <Trans>Next</Trans>}
            </Button>
          )}
          {!continuous && (
            <Button {...closeProps} size="sm">
              <Trans>Close</Trans>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
